export const SITE_URL = "https://thegreatworkexperience.com";
export const SITE_NAME = "The Great Work Experience";
export const DEFAULT_OG_IMAGE = "/assets/og/home.svg";

export const localeLabels = {
  en: "English",
  es: "Español",
  nl: "Nederlands",
  pap: "Papiamentu"
};

export const sectionLabels = {
  home: "Home",
  "start-here": "Start Here",
  programs: "Podcasts",
  media: "Videos",
  seasons: "Seasons",
  episodes: "Episodes",
  courses: "Courses",
  events: "Events",
  articles: "Articles",
  library: "Library",
  downloads: "Downloads",
  about: "About",
  donate: "Donate",
  policy: "Policy",
  terms: "Terms",
  "accreditation-statement": "Accreditation Statement",
  "code-of-moral-conduct": "Code of Moral Conduct"
};

export const defaultDescriptions = {
  home: "A public threshold into initiatic education, natural law, truth, freedom, and the Great Work.",
  "start-here": "Begin the Great Work through orientation, purification, and the seven-stage journey from ignorance to service.",
  programs: "TGWE MP3 podcast archive in chronological order.",
  media: "Video cycles, Eigen Pad seasons, embedded transmissions, and study materials.",
  seasons: "Season-level questions, archetypes, transformation purposes, materials, and ordered episodes.",
  episodes: "TGWE transmissions with media, study materials, previous and next navigation, and related study paths.",
  courses: "Public courses that prepare students for practice and deeper protected study.",
  events: "Upcoming TGWE sessions, live streams, replays, and past gatherings in one place.",
  articles: "TGWE articles with exact PDF links and readable summaries.",
  library: "TGWE study materials, PDFs, media files, and public resource folders.",
  downloads: "TGWE tools and software records grouped by release state.",
  about: "Mission, founder biography, moral covenant, and public TGWE context.",
  donate: "Traceable public support links for The Great Work Experience.",
  policy: "Privacy and donation policy for The Great Work Experience.",
  terms: "Terms for using TGWE public materials, media, courses, and linked study paths.",
  "accreditation-statement": "Independent education and accreditation statement for TGWE public courses.",
  "code-of-moral-conduct": "TGWE moral covenant for public study, teaching, speech, and support."
};

export function absoluteUrl(path = "/") {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
